<template>
  <div class="activation-wrap">
    <section id="activacion" class="activation-section">
      <div class="container">
        <div class="section-header text-center mb-4">
          <h2 class="section-title">Cómo se activa tu plan</h2>
        </div>
        <div class="steps">
          <div v-for="(step, i) in steps" :key="i">
            <span class="when">{{ step.when }}</span>
            <h3>{{ step.title }}</h3>
            <p>{{ step.text }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="disclaimers" class="disclaimers-section">
      <div class="container">
        <div class="section-header text-center mb-4">
          <h2 class="section-title">Lo que debes saber antes de inscribirte</h2>
        </div>
        <div class="know">
          <div v-for="(item, i) in know" :key="i">
            <h3>{{ item.title }}</h3>
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/**
 * Activación del plan + disclaimers legales/comerciales (mockup 2027).
 */
export default {
  name: 'ActivationDisclaimersSection',
  data() {
    return {
      steps: [
        {
          when: 'Día 1',
          title: 'Empieza tu plan',
          text: 'Consultas ilimitadas, video consulta, descuentos, salud mental y WhatsApp.'
        },
        {
          when: 'Mes 3',
          title: 'Se activa tu Wellness',
          text:
            'Exámenes 100% cubiertos y regalo de bienvenida en los planes Senior y Plus. Los 3 meses deben ser consecutivos.'
        },
        {
          when: 'Atajo',
          title: 'Paga 3 meses por adelantado',
          text: 'Todo se activa desde el día 1, Wellness incluido.'
        }
      ],
      know: [
        {
          title: 'No es un seguro médico',
          text:
            'Es una membresía médica. No cubre hospitalización, emergencias, cirugías ni especialistas fuera de nuestras sedes.'
        },
        {
          title: 'En una emergencia',
          text: 'Llama al 911 o ve a la sala de emergencias más cercana.'
        },
        {
          title: 'Cancela cuando quieras',
          text: 'Sin penalidad. Si cancelas o dejas de pagar, reactivar cuesta $25.'
        },
        {
          title: 'Pago mensual automático',
          text: 'Con tarjeta de débito o crédito. Precios por persona inscrita.'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.activation-section {
  padding: 80px 0 40px;
  background: $landing-bg-light;
}

.disclaimers-section {
  padding: 40px 0 80px;
  background: $landing-bg-light;
}

.section-title {
  font-size: clamp(1.75rem, 3vw, 2.5rem);
  font-weight: 800;
  color: $landing-primary-color;
  margin: 0;
}

.steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  counter-reset: s;
  margin-top: 28px;
}

.steps > div {
  padding: 0 28px 0 0;
  position: relative;
}

.steps > div::before {
  counter-increment: s;
  content: counter(s);
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: $landing-primary-color;
  color: #fff;
  font-weight: 800;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}

.steps > div::after {
  content: '';
  position: absolute;
  top: 21px;
  left: 44px;
  right: 0;
  height: 2px;
  background: $landing-border-light;
}

.steps > div:last-child::after {
  display: none;
}

.when {
  font-weight: 700;
  color: $landing-accent-text;
  font-size: 0.95rem;
}

.steps h3 {
  margin: 6px 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: $landing-primary-color;
}

.steps p {
  color: $landing-text-medium;
  margin: 0;
  line-height: 1.45;
}

.know {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 28px;
}

.know > div {
  border-left: 4px solid $landing-teal;
  padding: 6px 0 6px 20px;
}

.know h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: $landing-primary-color;
}

.know p {
  color: $landing-text-medium;
  margin-top: 6px;
  margin-bottom: 0;
  line-height: 1.45;
}

@media (max-width: 760px) {
  .activation-section {
    padding: 48px 0 24px;
  }

  .disclaimers-section {
    padding: 24px 0 48px;
  }

  .steps {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .steps > div::after {
    display: none;
  }

  .know {
    grid-template-columns: 1fr;
  }
}
</style>
